<template>
  <van-popup
    closeable
    round
    :style="{
      width: '90%',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5',
      margin: '0 auto'
    }"
  >
    <div class="statement-bg">
      <div class="comment-title">评论成功，待审核</div>
      <div class="statement-title">
        下载中山+写评论可领随机红包<br />每日额度领完即止
      </div>
      <wx-open-launch-app
        id="launch-btn"
        appid="wxc9da92efaf026389"
        :extinfo="exinfo"
        style="width: 80%; height: 55px"
        @launch="handleLaunch"
        @error="handleError"
      >
        <component
          :is="'script'"
          v-bind="{ type: 'text/wxtag-template' }"
        >
          <button
            style="
              background: linear-gradient(to left, #f48260, #e53531);
              border-width: 0;
              color: #fff;
              font-weight: 400;
              text-align: center;
              width: 200px;
              height: 40px;
              line-height: 40px;
              border-radius: 20px;
              margin: 10px auto;
              display: block;
              font-size: 14px;
              box-shadow: 0px 2px 5px #f48260;
            "
          >
            <span>打开中山+APP查看</span>
          </button>
        </component>
      </wx-open-launch-app>
    </div>
  </van-popup>
</template>

<script setup>
import { Popup as VanPopup } from "vant";
import { defineProps, defineOptions, computed } from "vue";
// 定义组件名称
defineOptions({
  name: "StatementPopup"
});

// 定义props
const props = defineProps({
  // showJump: Boolean,
  exinfo: {
    type: String,
    default: ""
  }
});

// 定义emit
// const emit = defineEmits(["updateJumpState"]);

// 处理启动应用
const handleLaunch = (e) => {
  console.log("handleLaunch", e);
};

// 处理错误
const handleError = (e) => {
  console.log("handleError", e);
  window.open("http://www.zsnews.cn/app/mobile.html?platform=mobile", "_blank");
};

// 计算属性
// const show = computed({
//   get() {
//     return props.showJump;
//   },
//   set(value) {
//     emit("updateJumpState", value);
//   }
// });

const exinfo = computed({
  get() {
    return props.exinfo;
  },
  set(value) {
    console.log("exinfo", value);
  }
});
</script>

<style scoped>
.launch-btn-box {
  margin: 12px 0;
}
.comment-title {
  font-size: 16px;
  text-align: center;
  font-weight: 600;
}
.statement-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 25rem;
  text-align: left;
  margin: 0.9375rem 0;
  padding: 0.3125rem 0.625rem;
  overflow-y: auto;
}
.title {
  text-align: center;
  font-size: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.content {
  text-align: justify;
  font-size: 16px;
  padding: 10px;
}
.statement-title {
  margin-top: 15px;
  padding: 0 10px;
  text-align: center;
}
</style>
